export default {
    'FORBIDDEN.NOT.MANAGER': 'This user has not a Manager profile, in consequence he can not use Calizy SaaS, please contact the administrator of your account' +
        ' to obtain the Manager profile',
};
